/**
 * Creates an onChange handler that validates the event value against an enum before calling the setter.
 * Useful for MUI Select/RadioGroup components where e.target.value is typed as string.
 * @param enumObj
 * @param setter
 */
export function createEnumChangeHandler<T extends string>(
  enumObj: Record<string, T>,
  setter: (value: T) => void
): (e: { target: { value: string } }) => void {
  return (e) => {
    const match = Object.values(enumObj).find((v) => v === e.target.value);
    if (match !== undefined) setter(match);
  };
}
